export default __webpack_public_path__ + "static/7-90cdff50c8a3dbddfd0ea062603c0ae5.jpg";